import type { ComponentProps } from "react";
import { useGlobals } from "~/hooks/useGlobals";
import { useReturnUrl } from "~/hooks/useReturnUrl";

export function Form({ children, ...props }: ComponentProps<"form">) {
  const { antiForgery } = useGlobals() || {};
  const returnUrl = useReturnUrl();

  return (
    <form {...props}>
      {antiForgery && (
        <input
          name={antiForgery?.fieldName}
          value={antiForgery?.token}
          type="hidden"
        />
      )}

      {returnUrl && <input name="returnUrl" value={returnUrl} type="hidden" />}

      {children}
    </form>
  );
}
